<template>
	<div>
		<v-row>
			<v-col cols="12" md="6">
				<v-menu
					v-model="menu1"
					:close-on-content-click="false"
					:nudge-right="40"
					transition="scale-transition"
					offset-y
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-model="dateLocal"
						:label="dateLabel"
						prepend-icon="mdi-calendar"
						readonly
						v-bind="attrs"
						v-on="on"
					></v-text-field>
					</template>
					<v-date-picker
						v-model="dateLocal"
						@input="menu1 = false"
						:first-day-of-week="1"
					></v-date-picker>
				</v-menu>
			</v-col>
			<v-col cols="12" md="6">
				<v-menu
					ref="menu"
					v-model="menu2"
					:close-on-content-click="false"
					:nudge-right="40"
					:return-value.sync="timeLocal"
					transition="scale-transition"
					offset-y
					max-width="290px"
					min-width="290px"
					>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
						v-model="timeLocal"
						:label="timeLabel"
						prepend-icon="mdi-clock-time-four-outline"
						readonly
						v-bind="attrs"
						v-on="on"
						></v-text-field>
					</template>
					<v-time-picker
						v-if="menu2"
						v-model="timeLocal"
						:allowed-minutes="allowedMinutes"
						full-width
						@click:minute="$refs.menu.save(timeLocal)"
					></v-time-picker>
				</v-menu>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import moment from 'moment'

export default {
	name: 'DateTimePicker',
	props: {
		dateLabel: {
			type: String,
			required: true,
		},
		timeLabel: {
			type: String,
			required: true,
		},
		substractMonthFromCurrent: {
			type: Number,
			default: 0,
		},
		substractDayFromCurrent: {
			type: Number,
			default: 0,
		},
		time: {
			required: true,
		},
		date: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			menu1: false,
			menu2: false,
			dateLocal: (new Date(this.date.subtract(this.substractDayFromCurrent, 'day'))).toISOString().substr(0, 10),
			timeLocal: this.time,
		}
	},
	watch:{
		timeLocal: {
			handler() {
				const datetimeComputed = this.dateTimeComputed
				this.emitDateTime(datetimeComputed)
			},
		},
		dateLocal: {
			handler() {
				const datetimeComputed = this.dateTimeComputed
				this.emitDateTime(datetimeComputed)
			},
		},
	},
	computed: {
		dateTimeComputed() {
			const timeArray = this.timeLocal.split(':')
			const returnDate = new Date(moment(this.dateLocal)
				.hours(0)
				.minutes(0)
				.seconds(0)
				.add(timeArray[0], 'hours')
				.add(timeArray[1], 'minutes'))
			return returnDate
		},
	},
	methods: {
		emitDateTime(value) {
			this.$emit('datetimeEmit', value)
		},
		allowedMinutes: (minute) => minute % 5 === 0,
	},
	mounted() {
		this.emitDateTime(this.dateTimeComputed)
	},
}
</script>

<style>

</style>
